import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  background: linear-gradient(180deg, rgba(204, 204, 204, 0.222) 0%, rgba(248, 247, 245, 0) 100%);
  overflow: hidden;

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(60)};
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.downMd} {
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};
  margin-bottom:  ${em(40)};
  color: var(--color-D100);

  ${p => p.theme.mq.upLg} {
    gap: ${em(15)};
    margin-bottom:  ${em(60)};
  }
`

export const Title = styled(Text)`
  text-align: center;

  span {
    color: var(--color-V50);
  }
`

export const Description = styled(Text)`
  text-align: center;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(772, 22)};
    margin: 0 auto;
  }
`

export const ImageBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${p => p.theme.mq.upLg} {
    gap: ${em(70)};
  }
`

export const Image = styled.img`
  display: block;
  max-width: 61.5%;
  align-self: center;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(426)};
  }
`

export const RightIcons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(18)};
  transform: translateX(50%);

  & > div:first-child {
    margin-left: ${em(60)};
  }

  & > div:last-child {
    margin-left: ${em(60)};
  }

  ${p => p.theme.mq.downMd} {
    & > div:nth-child(2) {
      height: ${em(72)};
    }
  }

  ${p => p.theme.mq.upLg} {
    transform: none;
    gap: ${em(40)};
  }
`

export const LeftIcons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${em(18)};
  transform: translateX(-50%);

  & > div:first-child {
    margin-right: ${em(60)};
  }

  & > div:last-child {
    margin-right: ${em(60)};
  }

  ${p => p.theme.mq.downMd} {
    & > div:nth-child(2) {
      height: ${em(72)};
    }
  }

  ${p => p.theme.mq.upLg} {
    transform: none;
    gap: ${em(40)};
  }
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${em(93)};
  gap: ${em(6)};
  padding: ${em(12)} 0 ${em(12)};
  background-color: var(--color-W100);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
  border-radius: ${em(20)};

  svg {
    width: ${em(18)};
    height: ${em(18)};

    ${p => p.theme.mq.upLg} {
      width: ${em(30)};
      height: ${em(30)};
    }
  }

  ${p => p.theme.mq.upMd} {
    width: ${em(220)};
    gap: ${em(10)};
    padding: ${em(20)} 0 ${em(20)};
  }
`

export const IconText = styled(Text)`
  color: var(--color-D50);
  text-align: center;

  ${p => p.theme.mq.downMd} {
    font-size: 9px;
    line-height: 12px;
  }

  ${p => p.theme.mq.upMd} {
    max-width: ${em(171)};
  }
`
